import { usePostLogin } from '@api';
import { LoginErrorStatusEnum, LoginErrorTextEnum, PathnameEnum } from '@constant';
import { useAuthActions } from '@remote-hooks';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

//로그인페이지 로직에 관여
export const useLogin = () => {
  const [ipAddress, setIpAddress] = useState<string | null>(null);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState<boolean>(false);

  const { onLogin } = useAuthActions();
  const navigate = useNavigate();

  const {
    mutate: postLoginMutate,
    error: postLoginError,
    isPending: isLoginPending
  } = usePostLogin(
    (response) => {
      onLogin(response.data.data);
      navigate(PathnameEnum.MAIN_PAGE);
    },
    () => {
      setIsErrorModalVisible(true);
    }
  );

  const errorMessage = postLoginError?.response?.data?.errorMessage;

  const getErrorModalContent = () => {
    if (errorMessage === LoginErrorStatusEnum.EMAIL_NOT_FOUND) {
      return LoginErrorTextEnum.EMAIL_NOT_FOUND;
    } else if (errorMessage === LoginErrorStatusEnum.PASSWORD_INVALID) {
      return LoginErrorTextEnum.PASSWORD_INVALID;
    } else if (errorMessage === LoginErrorStatusEnum.IP_INVALID) {
      return LoginErrorTextEnum.IP_INVALID;
    } else {
      //postLoginError가 null이면서 해당 함수가 call되는 경우는 ip주소 불러오기에 실패한 경우이므로 LoginErrorTextEnum.INVALID_IP를 return
      return LoginErrorTextEnum.UNKNOWN_ERROR;
    }
  };

  //해당 함수는 id와 pw가 입력되지 않았다면 버튼을 클릭하더라도 실행되지 않음
  const handleLoginButtonClick = (data: Record<string, any>) => {
    if (ipAddress) {
      postLoginMutate({ email: data.email, password: data.password, ip: ipAddress });
    } else {
      setIsErrorModalVisible(true);
    }
  };

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get('https://api64.ipify.org?format=json');
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error('Failed to get IP address:', error);
      }
    };

    fetchIP();
  }, []);

  return {
    handleLoginButtonClick,
    isErrorModalVisible,
    setIsErrorModalVisible,
    getErrorModalContent,
    isLoginPending
  };
};
